import type { AttachmentViewState } from 'owa-attachment-data';
import { isSmimeAttachmentType } from 'owa-attachment-model-store';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import { isLinkAttachment } from 'owa-attachment-model-store/lib/utils/isLinkAttachment';

export default function isAttachmentDownloadable(attachment: AttachmentViewState): boolean {
    const attachmentModel = getAttachment(attachment.attachmentId);
    if (!attachmentModel) {
        return false;
    }
    return isSmimeAttachmentType(attachmentModel.model)
        ? true
        : attachmentModel.download.url &&
              attachmentModel.info?.allowDownload &&
              !isLinkAttachment(attachment.attachmentId);
}
